import React, {useEffect, useRef, useState} from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    styled,
    TextField,
    Tooltip
} from "@mui/material";
import ShowMessage from "../utils/show-message";
import useTimeout from "../utils/useTimeout";
import {CustomBackdrop} from "../utils/customStyles";
import {ApiUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";
import ShowSnackbar from "../utils/ShowSnackbar";
import {validateEmail} from "../utils/portal-helper";
import {Transition} from "../users/OrganizationUserAddDialog";

const StyledTextField = styled(TextField)({
    marginBottom: 10,
})
const statusList = ['TEST', 'ACTIVE', 'INACTIVE'];

export default function HispsCreateDialog(props) {
    const dialogRef = useRef(null);
    const setCreateHispDialog = props.setCreateHispDialog;
    const createHispDialog = props.createHispDialog;
    const setRefresh = props.setRefresh;
    const hisps = props.hispResult || [];
    const refresh = props.refresh;

    const [loading, setLoading] = useState(false);
    const [msg, setMsg] = useState({});
    const [hispStatus, setHispStatus] = useState('');
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg:'', msgLv: ''});
    const [errorEmailMsg, setErrorEmailMsg] = useState("");
    const [errorStewardEmailMsg, setErrorStewardEmailMsg] = useState("");

    useEffect(() => {
        setHispStatus("");
    }, [refresh])

    const handleClose = () => {
        const dialogForm = dialogRef.current;
        if (dialogForm.hispId.value && dialogForm.hispName.value && hispStatus && !errorEmailMsg.length && !errorStewardEmailMsg.length) {
            setCreateHispDialog({...createHispDialog, open: false})
        }
    };

    const handleCancel = () => {
        setCreateHispDialog({...createHispDialog, open: false})
    }

    const DialogAlert = () => {
        useTimeout(() => setMsg({}), 5000);
        return <ShowMessage msg={msg} />
    }

    const isEmailExist = (email) => {
        let exist;
        if (hisps) {
            exist = hisps.filter( h => h.contactEmail === email);
        }
        return exist.length > 0;
    }

    const handleEmailChange = () => {
        const input = dialogRef.current.contactEmail.value;

        if (!validateEmail(input) && input.length > 0) {
            setErrorEmailMsg("Please provide a valid email address");
            return;
        }

        if (validateEmail(input) && isEmailExist(input)) {
            setErrorEmailMsg("This Email Address has been taken")
            return;
        }
        // create hisp don't require email, so the length can be 0
        setErrorEmailMsg("");
    }

    const handleStewardEmailChange = () => {
        const input = dialogRef.current.stewardContactEmail.value;

        if (!validateEmail(input) && input.length > 0) {
            setErrorStewardEmailMsg("Please provide a valid email address");
            return;
        }

        if (validateEmail(input) && isEmailExist(input)) {
            setErrorStewardEmailMsg("This Email Address has been taken")
            return;
        }
        // create hisp don't require email, so the length can be 0
        setErrorStewardEmailMsg("");
    }

    const handleHispStatusChange = (event) => {
        const status = event.target.value;
        setHispStatus(status);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = {}
        const dialogForm = dialogRef.current;

        if (errorEmailMsg.length > 0 || errorStewardEmailMsg.length > 0) {
            return;
        }

        form["hispId"] = dialogForm.hispId.value;
        form["hispName"] = dialogForm.hispName.value;
        form["contactName"] = dialogForm.contactName.value;
        form["contactEmail"] = dialogForm.contactEmail.value;
        form["contactPhone"] = dialogForm.contactPhone.value;
        form["stewardContactName"] = dialogForm.stewardContactName.value;
        form["stewardContactEmail"] = dialogForm.stewardContactEmail.value;
        form["stewardContactPhone"] = dialogForm.stewardContactPhone.value;
        form["status"] = hispStatus;
        form["comment"] = dialogForm.comment.value;
        form['logoUrl'] = dialogForm.logoUrl.value

        /** admin feature */
        // let feature;
        // if (hispFeature.length) {
        //     feature = hispFeature === 'YES';
        // } else {
        //     feature = false;
        // }
        // form["admin"] = feature;

        setCreateHispDialog({...createHispDialog, hisp: form});

        const requestOption = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(form)
        }

        const url = ApiUrl.Hisps.crateHisp.getPath;
        console.log("Post request: " + url);

        setLoading(true);

        try {
            const res = await fetch(url, requestOption)
            const data = await handleHttpResponse(res);
            console.log(data);
            setSnackbarMsg({open: true, msg: `Successfully create new hisp: ${form['hispId']}`, msgLv: 'success'})
            setRefresh(new Date().getTime());
        } catch (err) {
            console.error("Failed to POST request: " + err);
            setSnackbarMsg({open: true, msg: `Unable to create new hisp: ${form['hispId']}`, msgLv: 'error'});
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            {msg && <DialogAlert/> }
                <Dialog
                    open={createHispDialog.open}
                    onClose={handleClose}
                    PaperProps={{style: {borderRadius: 12}}}
                    TransitionComponent={Transition}
                >
                    <DialogTitle color="white"
                                 sx={{backgroundColor: "rgba(60,120,185,1)"}}
                    >
                        New HISP Entry
                    </DialogTitle>
                    <DialogContent>
                        <form onSubmit={handleSubmit} id='hispCreateForm' ref={dialogRef}>
                            <StyledTextField
                                required
                                sx={{mt: "10px"}}
                                autoComplete="off"
                                id="hispId"
                                label="Hisp ID"
                                fullWidth
                                variant="standard"
                            />
                            <StyledTextField
                                required
                                autoComplete="off"
                                id="hispName"
                                label="Hisp Name"
                                fullWidth
                                variant="standard"
                            />
                            <StyledTextField
                                autoComplete="off"
                                id="contactName"
                                label="Contact Name"
                                // label="Technical Contact Name"
                                fullWidth
                                variant="standard"
                            />
                            <StyledTextField
                                autoComplete="off"
                                id="contactEmail"
                                label="Contact Email"
                                // label="Technical Contact Email"
                                fullWidth
                                variant="standard"
                                onChange={handleEmailChange}
                                error={!!errorEmailMsg.length}
                                helperText={errorEmailMsg}
                            />
                            <StyledTextField
                                autoComplete='off'
                                id='contactPhone'
                                label='Contact Phone'
                                // label="Technical Contact Phone"
                                fullWidth
                                variant='standard'
                            />
                            <StyledTextField
                                autoComplete="off"
                                id="stewardContactName"
                                label="Steward Contact Name"
                                fullWidth
                                variant="standard"
                            />
                            <StyledTextField
                                autoComplete="off"
                                id="stewardContactEmail"
                                label="Steward Contact Email"
                                fullWidth
                                variant="standard"
                                onChange={handleStewardEmailChange}
                                error={!!errorStewardEmailMsg.length}
                                helperText={errorStewardEmailMsg}
                            />
                            <StyledTextField
                                autoComplete='off'
                                id='stewardContactPhone'
                                label='Steward Contact Phone'
                                fullWidth
                                variant='standard'
                            />
                            <StyledTextField
                                autoComplete="off"
                                required
                                id="status"
                                label="Status"
                                fullWidth
                                variant="standard"
                                select
                                onChange={handleHispStatusChange}
                                value={hispStatus}
                            >
                                {statusList.map((s, i) => (
                                    <MenuItem key={i} value={s}>
                                        {s}
                                    </MenuItem>
                                ))}
                            </StyledTextField>
                            <StyledTextField
                                autoComplete="off"
                                id="logoUrl"
                                label="Hisp Logo"
                                fullWidth
                                variant="standard"
                                placeholder="Logo Url"
                            />
                            <StyledTextField
                                autoComplete="off"
                                id="comment"
                                label="Comment"
                                fullWidth
                                variant="standard"
                            />

                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button type="submit" form="hispCreateForm" onClick={handleClose} variant="contained">Save</Button>
                        <Button onClick={handleCancel} variant="outlined">Cancel</Button>
                    </DialogActions>
                </Dialog>
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
            <CustomBackdrop open={loading} />
        </div>
    );
}